import { memo, PropsWithChildren } from 'react';
import { ButtonGroupProps } from '../button.types';
import { ButtonGroupContext } from './button-group.context';
import { StyledButtonGroup } from './button-group.styled';

export const ButtonGroup = memo(
  ({ children, ...buttonProps }: PropsWithChildren<ButtonGroupProps>) => {
    return (
      <ButtonGroupContext.Provider value={buttonProps}>
        <StyledButtonGroup>{children}</StyledButtonGroup>
      </ButtonGroupContext.Provider>
    );
  }
);

ButtonGroup.displayName = 'ButtonGroup';
